import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postTaskClick,
  type PostTaskClickParams,
  type PostTaskClickResponse,
} from '@services/TasksService';

export type UsePostTaskClickParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostTaskClickResponse,
    unknown,
    string,
    PostTaskClickParams,
    PostTaskClickResponse
  >;
};

export const postTaskClickMutationKey = 'post-task-click';

export const usePostTaskClick = ({
  mutationOptions,
}: UsePostTaskClickParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostTaskClickResponse,
    unknown,
    string,
    PostTaskClickParams
  >(
    postTaskClickMutationKey,
    (_url, { arg }) => postTaskClick(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
